// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3M91H","textarea":"styles_textarea__35BCx"};